import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useObraItensChecklistAreaVerificacaoPagination
 */

type State = {
  inspecaoObraItens: PaginationProperties,
  executadoPor: PaginationProperties,
  ocorrencias: PaginationProperties,
};

type Actions = {
  inspecaoObraItensSetter: SetPaginationProperties,
  executadoPorSetter: SetPaginationProperties,
  ocorrenciasSetter: SetPaginationProperties,
};

export const useObraItensChecklistAreaVerificacaoPagination = create<State & Actions>((set) => ({
  inspecaoObraItens: InitializePaginationProperties(),
  inspecaoObraItensSetter: InitializeSetPaginationProperties(set, "inspecaoObraItens"),

  executadoPor: InitializePaginationProperties(),
  executadoPorSetter: InitializeSetPaginationProperties(set, "executadoPor"),

  ocorrencias: InitializePaginationProperties(),
  ocorrenciasSetter: InitializeSetPaginationProperties(set, "ocorrencias"),
}));